export enum VillageWifiUserType {

    Device = 'Device'
    , Resident = 'Resident'
    , ByWifiKey = 'ByWifiKey'
    , Visitor = 'Visitor'

};